function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 480",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface323783990"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725491%,80.784315%,41.960785%)",
      fillOpacity: 1
    },
    d: "M 300 75 C 291.71875 75 285 81.71875 285 90 C 285 98.28125 291.71875 105 300 105 L 353.789062 105 L 229.394531 229.394531 C 223.535156 235.253906 223.535156 244.746094 229.394531 250.605469 C 232.328125 253.539062 236.160156 255 240 255 C 243.839844 255 247.671875 253.539062 250.605469 250.605469 L 375 126.210938 L 375 180 C 375 188.28125 381.71875 195 390 195 C 398.28125 195 405 188.28125 405 180 L 405 90 C 405 81.71875 398.28125 75 390 75 Z M 135 90 C 110.183594 90 90 110.183594 90 135 L 90 345 C 90 369.816406 110.183594 390 135 390 L 345 390 C 369.816406 390 390 369.816406 390 345 L 390 255 C 390 246.71875 383.28125 240 375 240 C 366.71875 240 360 246.71875 360 255 L 360 345 C 360 353.273438 353.273438 360 345 360 L 135 360 C 126.726562 360 120 353.273438 120 345 L 120 135 C 120 126.726562 126.726562 120 135 120 L 225 120 C 233.28125 120 240 113.28125 240 105 C 240 96.71875 233.28125 90 225 90 Z M 135 90 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.74ce2401d684101cc83125c6dac8ce9c.svg";
export { ForwardRef as ReactComponent };